import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import './App.css';
import Register from './Register';
import Verify from './Verify';
import Dashboard from './Dashboard';
import ProtectedRoute from './ProtectedRoute';
import Chat from './Chat';
import Navbar from './Navbar';
import './Navbar.css';

function Login({ setUser }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token) {
      verifyToken(token);
    }
  }, []);

  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google/login`;
  };

  const verifyToken = async (token) => {
    console.log('Token received:', token);
    const payload = { token };
    console.log('Request payload:', payload);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/google`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      console.log('Response status:', response.status);
      const userData = await response.json();
      console.log('User data:', userData);
      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('token', userData.token);
      navigate('/dashboard');
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (error) {
      console.error('Error verifying token:', error);
    }
  };

  const handleLocalLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/local`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || `Login failed with status: ${response.status}`);
      }
      const userData = await response.json();
      console.log('Local login successful:', userData);
      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('token', userData.token);
      navigate('/dashboard');
    } catch (error) {
      console.error('Local login error:', error);
      alert(error.message);
    }
  };

  return (
    <div className="App">
      <div className="login-container">
        <h2>Login</h2>
        <div className="login-methods">
          <button className="google-login-button" onClick={handleGoogleLogin}>
            <img
              src="https://developers.google.com/identity/images/g-logo.png"
              alt="Google logo"
              className="google-icon"
            />
            Continue with Google
          </button>
          <form className="local-login-form" onSubmit={handleLocalLogin}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
            />
            <button type="submit" className="local-login-button">
              Login
            </button>
          </form>
        </div>
        <p className="signup-link">
          Don't have an account? <Link to="/register">Sign up</Link>
        </p>
      </div>
    </div>
  );
}

const App = () => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  const ProtectedLayout = ({ children }) => (
    <div className="app-container">
      <Navbar user={user} onLogout={handleLogout} />
      <div className="content">{children}</div>
    </div>
  );

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login setUser={setUser} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify" element={<Verify />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute user={user}>
              <ProtectedLayout>
                <Dashboard user={user} onLogout={handleLogout} />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat"
          element={
            <ProtectedRoute user={user}>
              <ProtectedLayout>
                <Chat user={user} />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;